
// export const BASE_URL =  'http://192.168.1.5/chokidar-app/public/api';
export const BASE_URL =  'https://smartchokidar.com/backend/api';

//test

export const fetchWithFormDataToken = async (endpoint, formdata, token = null, abortController = null) => {
    const url = `${BASE_URL}/${endpoint}`;
  
    try {
      const headers = { 'Authorization': `Bearer ${token}` }
    //   const headers = {
    //     'Content-Type': 'application/json',
    //     'Accept': 'application/json'
    // }

      const requestOptions = {
        method: "POST",
        body: formdata,
        headers: headers,
        redirect: "follow"
      };
  
      if (abortController) {
        requestOptions.signal = abortController.signal;
      }
  
      const response = await fetch(url, requestOptions);
      const result = await response.json();
      return result;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };